import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows, differenceStats } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { StatNumber } from './StatNumber';
export function Difference() {
  return <section className="w-full bg-bone px-5 py-20 sm:py-28" data-id="element-49" data-mp="58z4nwbiuga3">
      <div className="mx-auto max-w-6xl" data-id="element-50" data-mp="57ecgdcoj9fe">
        <SectionHeading eyebrow="La diferencia del Kit" title={<>
              De docente agotado a{' '}
              <span className="text-brand" data-id="element-52" data-mp="3ri0c00m40j7s">referente indiscutido</span>
            </>} subtitle="Dale a tus clases una estructura profesional, a tus alumnos las ganas de hablar en inglés y a ti el tiempo de volver a disfrutar la docencia." data-id="element-51" data-mp="3mgujo3wd2xys" />

        <Reveal delay={0.06} data-id="element-53" data-mp="1bp1gqkwf6b59">
          <dl className="mx-auto mt-14 grid max-w-4xl grid-cols-1 overflow-hidden rounded-2xl border-2 border-ink bg-white sm:grid-cols-3" data-id="element-54" data-mp="1bpuckqtubg8m">
            {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-8 text-center ${index > 0 ? 'border-t-2 border-ink sm:border-l-2 sm:border-t-0' : ''}`} data-id="element-55" data-mp="1j9m5afbpws9n" data-mpi={index}>
                <dt className="sr-only" data-id="element-56" data-mp="1sznksiq092cy">{stat.label}</dt>
                <dd data-id="element-57" data-mp="1o25kthtytxh3">
                  <StatNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} className="block font-display text-5xl leading-none text-brand" data-id="element-58" data-mp="1o1m0juguewzw" />
                  <span className="mx-auto mt-4 block max-w-[14rem] text-sm font-semibold leading-snug text-ink/70" data-id="element-59" data-mp="wd2dft6s8708">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </Reveal>

        <Reveal delay={0.08} data-id="element-60" data-mp="2locmojyvxbpr">
          <h3 className="mt-20 text-center font-display text-2xl leading-tight text-ink sm:text-4xl" data-id="element-61" data-mp="2lrqonr3mziwo">
            El costo de improvisar <span className="text-ink/35" data-id="element-62" data-mp="2orirtreolmsn">vs.</span>{' '}
            <span className="text-brand" data-id="element-63" data-mp="2oqz9i9l4cwe3">el sistema definitivo</span>
          </h3>
        </Reveal>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-ink bg-white shadow-lift" data-id="element-64" data-mp="2sr111px549fn">
          <div className="grid grid-cols-1 border-b-2 border-ink md:grid-cols-2" data-id="element-65" data-mp="2xsqch6o9yp49">
            <div className="flex items-center gap-3 bg-bone px-6 py-5 md:border-r-2 md:border-ink" data-id="element-66" data-mp="32pp3hgcn6fy8">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-ink/10 text-ink/60" data-id="element-67" data-mp="254uk2e5qnjda">
                <XIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-68" data-mp="2a2mdxdpy1fk4" />
              </span>
              <span className="font-display text-lg text-ink/55" data-id="element-69" data-mp="2f04iyt0ubamu">
                Antes de INGLES LISTO
              </span>
            </div>
            <div className="flex items-center gap-3 bg-ink px-6 py-5" data-id="element-70" data-mp="1mda3kaivr1g8">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-volt text-ink" data-id="element-71" data-mp="1maxn61srsz5a">
                <CheckIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-72" data-mp="1jsc7j1zvnve5" />
              </span>
              <span className="font-display text-lg text-white" data-id="element-73" data-mp="1er69qprd1hxr">
                Con el Kit INGLES LISTO™
              </span>
            </div>
          </div>

          <ul data-id="element-74" data-mp="14u1msnpoxifw">
            {comparisonRows.map((row, index) => <li key={row.beforeTitle} className={`grid grid-cols-1 md:grid-cols-2 ${index > 0 ? 'border-t-2 border-ink/10' : ''}`} data-id="element-75" data-mp="10t7yht8c61mh" data-mpi={index}>
                <Reveal delay={index * 0.03} className="border-b border-ink/10 bg-white px-6 py-6 md:border-b-0 md:border-r-2 md:border-ink/10 md:px-8" data-id="element-76" data-mp="w0wx0lxy67rt">
                  <p className="font-display text-base text-ink/50" data-id="element-77" data-mp="h5h9z0vsbc4x">
                    {row.beforeTitle}
                  </p>
                  <p className="mt-2 text-base leading-relaxed text-ink/60" data-id="element-78" data-mp="d3ner84cz0c5">
                    {row.beforeText}
                  </p>
                </Reveal>
                <Reveal delay={index * 0.03 + 0.03} className="bg-brand-light/40 px-6 py-6 md:px-8" data-id="element-79" data-mp="11ww0umo1yolo">
                  <p className="font-display text-base text-brand-dark" data-id="element-80" data-mp="t1gaifmiarku">
                    {row.afterTitle}
                  </p>
                  <p className="mt-2 text-base font-medium leading-relaxed text-ink/80" data-id="element-81" data-mp="x1qe5lmtt5wj">
                    {row.afterText}
                  </p>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}